import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ImageCard from '../../../shared/components/ImageCard';
import { usageLabel } from './usageLabel';

// One library image. The card asks for the thumbnail variant; the API hands back the original
// while a thumbnail is still being generated, so a freshly uploaded image appears immediately.
// Dimensions come from whichever file loaded — the server does not record them, and for a
// thumbnail they are the thumbnail's, which is why the caption says them only for originals.
export default function MediaImageCard({ item, fetchDownloadUrl, selected, onSelect }) {
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [size, setSize] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    fetchDownloadUrl(item.id, { variant: 'thumbnail' })
      .then((value) => { if (!cancelled) setUrl(value); })
      .catch(() => { if (!cancelled) setUrl(null); })
      .finally(() => { if (!cancelled) setLoading(false); });

    return () => { cancelled = true; };
  }, [item.id, fetchDownloadUrl]);

  const used = (item.usage_count || 0) > 0;
  // The API knows the original's size once a thumbnail has been made; until then the card is
  // showing the original itself, so what it loaded is the right answer.
  const dimensions = (item.width && item.height)
    ? `${item.width}×${item.height}`
    : (size ? `${size.width}×${size.height}` : '');

  return (
    <ImageCard
      src={url}
      loading={loading}
      title={item.filename}
      meta={dimensions}
      aside={(
        <span className={`text-nowrap ${used ? 'text-primary' : 'text-muted'}`}>
          {usageLabel(item.usage_count)}
        </span>
      )}
      selected={selected}
      onClick={() => onSelect(item)}
      onImageLoad={item.width ? undefined : setSize}
    />
  );
}

MediaImageCard.propTypes = {
  item: PropTypes.object.isRequired,
  fetchDownloadUrl: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
};

MediaImageCard.defaultProps = { selected: false };
